const styles = {
    sessionAlertPopUp: {
        backgroundColor: '#3876AA',
        color: 'white',
        textTransform: 'none',
        borderRadius: 2,
        p: 2,
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
    },
    signOut: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#ED0000',
    },
    cancel: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        mr: 2,
        borderWidth: '2px',
    },
};
export default styles;
